import Tooltip from 'components/tooltip/Tooltip';
import {
  ConnectionConfigType,
  Integration,
  IntegrationEnum,
} from 'models/InternalIntegrationSetting';
import { Trans, useTranslation } from 'react-i18next';
import GearIcon from 'assets/images/icons/gear-filled.svg?react';
import { IconLinkStyled } from 'pages/integrations/integrationDetails/components/propertiesList/propertiesResults/propertyListItem/PropertyListItem.styles';

const V2_CHANNELS_PATHS = {
  [IntegrationEnum.BOOKING_COM]: '/channels/bookingdotcom/sync',
  [IntegrationEnum.HVMI]: '/channels/default/sync?chname=HVMB',
  [IntegrationEnum.AIRBNB]: '/channels/airbnb/sync',
  [IntegrationEnum.HOMEAWAY]: '/channels/vrbo/sync',
};

const ManageChannelLink = ({ integration }: { integration: Integration }) => {
  const { t } = useTranslation();

  const getUrl = () => {
    const { connectionConfig, enumId } = integration;

    const isTypeOutboundOauth =
      connectionConfig.type === ConnectionConfigType.OUTBOUND_OAUTH;

    // Redirect to V2 details page for OutboundOauth channels: Airbnb, HomeAway, Booking.com, and HVMI
    if (isTypeOutboundOauth) {
      const path = V2_CHANNELS_PATHS[enumId as keyof typeof V2_CHANNELS_PATHS];

      return path;
    }

    return `/channels/details/${enumId}`;
  };

  return (
    <Tooltip
      id="manage-channel-icon"
      text={<Trans i18nKey="pageProperty.channels.manageThisChannel" />}
    >
      <IconLinkStyled
        to={getUrl()}
        aria-label={t('pageProperty.channels.manageThisChannel')}
        data-testid="manage-channel-icon"
      >
        <GearIcon />
      </IconLinkStyled>
    </Tooltip>
  );
};

export default ManageChannelLink;
